// extracted by mini-css-extract-plugin
export default {"tuberculosisContainer":"tuberculosis_tuberculosisContainer__fN8FI","title":"tuberculosis_title__zVb-Z","content":"tuberculosis_content__DnKwy"};